<template>
  <button @click="$emit('input', id)" :class="[active, 'tab']">
    <div class="tab-text">
      {{ label }} -
      <i :class="{ caution: caution }">{{ subLabel }}</i>
      <!-- <i :class="{ caution: caution }">{{ subLabel }}{{ maxShow }}</i> -->
    </div>
  </button>
</template>

<script>
export default {
  props: {
    id: String,
    label: String,
    subLabel: [String, Number],
    maxLabel: [String, Number],
    caution: Boolean,
    value: String,
  },
  computed: {
    active() {
      return this.value === this.id ? 'active' : false;
    },
    maxShow() {
      return this.maxLabel ? '(' + this.maxLabel + ')' : '';
    },
  },
};
</script>

<style scoped>
.tab {
  border-radius: 2px 2px 0 0;
  background: #fff;
  color: #311d0a;
  line-height: 24px;
}
.tab-text {
  border-bottom: 1px solid #dedede;
  margin: 0 5px;
}
.tab:hover {
  background: #eeeeee;
}
.active {
  background: #f7c9c9;
}

.caution {
  color: #bd0000;
  font-weight: 500;
}
</style>
